/**
 * Created by huangzhangshu on 2018/8/8
 */
import React, {Component} from 'react';
import {connect} from 'dva';
import {Form, Input, Icon, Button, Alert, message} from '@vadp/ui';
import styles from './index.less';
import {wrapImage} from '../../utils';

const FormItem = Form.Item;

class LoginForHXYY_KYYZXJFCXXT extends Component {

  constructor(props) {
    super(props);
    this.state = {
      code: '',
      codeLength: 4,
      fontSizeMin: 20,
      fontSizeMax: 22,
      backgroundColorMin: 240,
      backgroundColorMax: 250,
      colorMin: 10,
      colorMax: 20,
      lineColorMin: 40,
      lineColorMax: 180,
      contentWidth: 96,
      contentHeight: 35,
      showError: false, // 默认不显示验证码的错误信息
      showVerify: true,
      visibility: 'hidden',
    };
  }

  componentWillMount() {
    this.canvas = React.createRef();
  }

  componentDidMount() {
    // const {showLoginVerify} = this.props;
    // this.setState({visibility: 'visible'});
    // 用户名输入框默认获取焦点
    document.getElementById('username').focus();
    this.drawPic();
  }

  componentWillReceiveProps(nextProps, nextContext) {
    const {showLoginVerify} = nextProps;
    if (this.state.showVerify !== showLoginVerify) this.setState({showVerify: showLoginVerify});
  }

  // 生成一个随机数
  // eslint-disable-next-line arrow-body-style
  randomNum = (min, max) => {
    return Math.floor(Math.random() * (max - min) + min)
  }

  drawPic = () => {
    this.randomCode();
  }

  // 随机生成验证码
  randomCode() {
    let random = '';
    // 去掉了I l i o O,可自行添加
    const str = 'QWERTYUPLKJHGFDSAZXCVBNMqwertyupkjhgfdsazxcvbnm1234567890'
    for (let i = 0; i < this.state.codeLength; i++) {
      const index = Math.floor(Math.random() * 57);
      random += str[index];
    }
    this.setState({
      code: random
    }, () => {
      const canvas = this.canvas.current;
      if (!canvas) return;
      const ctx = canvas.getContext('2d');
      ctx.textBaseline = 'bottom';
      // 绘制背景
      ctx.fillStyle = this.randomColor(this.state.backgroundColorMin, this.state.backgroundColorMax);
      ctx.fillRect(0, 0, this.state.contentWidth, this.state.contentHeight);
      // 绘制文字
      for (let i = 0; i < this.state.code.length; i++) {
        this.drawText(ctx, this.state.code[i], i);
      }
      this.drawLine(ctx);
      this.drawDot(ctx);
    });
  }

  // 生成一个随机的颜色
  // eslint-disable-next-line react/sort-comp
  randomColor(min, max) {
    const r = this.randomNum(min, max);
    const g = this.randomNum(min, max);
    const b = this.randomNum(min, max);
    return `rgb(${r}, ${g}, ${b})`;
  }

  drawText(ctx, txt, i) {
    ctx.fillStyle = this.randomColor(this.state.colorMin, this.state.colorMax);
    const fontSize = this.randomNum(this.state.fontSizeMin, this.state.fontSizeMax);
    ctx.font = fontSize + 'px SimHei';
    const padding = 10;
    const offset = (this.state.contentWidth - 40) / (this.state.code.length - 1);
    let x = padding;
    if (i > 0) {
      x = padding + (i * offset);
    }
    let y = this.randomNum(this.state.fontSizeMax, this.state.contentHeight - 5);
    if (fontSize > 40) {
      y = 40;
    }
    const deg = this.randomNum(-10, 10);
    // 修改坐标原点和旋转角度
    ctx.translate(x, y);
    ctx.rotate(deg * Math.PI / 180);
    ctx.fillText(txt, 0, 0);
    // 恢复坐标原点和旋转角度
    ctx.rotate(-deg * Math.PI / 180);
    ctx.translate(-x, -y);
  }

  drawLine(ctx) {
    // 绘制干扰线
    for (let i = 0; i < 1; i++) {
      ctx.strokeStyle = this.randomColor(this.state.lineColorMin, this.state.lineColorMax);
      ctx.beginPath();
      ctx.moveTo(this.randomNum(0, this.state.contentWidth), this.randomNum(0, this.state.contentHeight));
      ctx.lineTo(this.randomNum(0, this.state.contentWidth), this.randomNum(0, this.state.contentHeight));
      ctx.stroke();
    }
  }

  drawDot(ctx) {
    // 绘制干扰点
    for (let i = 0; i < 10; i++) {
      ctx.fillStyle = this.randomColor(0, 255);
      ctx.beginPath();
      ctx.arc(this.randomNum(0, this.state.contentWidth), this.randomNum(0, this.state.contentHeight), 1, 0, 2 * Math.PI);
      ctx.fill();
    }
  }

  reloadPic = () => {
    this.drawPic();
    this.props.form.setFieldsValue({
      code: '',
    });
    this.setState({userInputCode: ''});
  }

  // 输入验证码
  changeCode = e => {
    // this.setState({userInputCode: e.target.value.toLowerCase()});
  }

  onChange = () => {
    const {dispatch} = this.props;
    dispatch({type: 'vadpLogin/updateStatus', payload: true});
  }

  submit = (e) => {
    const {form, dispatch, showVerify = false} = this.props;
    const {code = ''} = this.state;
    const {getFieldsValue, setFieldsValue} = form;
    const {code: fieldCode = ''} = getFieldsValue();
    e.preventDefault();
    if(fieldCode === '' && showVerify ){
      message.warn('请输入验证码');
      return;
    }else if(code.toLocaleLowerCase() !== fieldCode.toLocaleLowerCase() && showVerify){
      message.warn('验证码错误，请重新输入');
      setFieldsValue({code: ''});
      this.reloadPic();
      return;
    }
    form.validateFields({force: true},
      (err, values) => {
        if (!err) {
          dispatch({type: 'vadpLogin/login', payload: {...values}});
        }
      },
    );
  }

  renderErrorMessage = (message) => {
    return (
      <Alert
        style={{marginBottom: 16}}
        message={message}
        type="error"
        showIcon
      />
    );
  }

  frogetPassword = () => {
    const {dispatch} = this.props;
    dispatch({ type: 'resetPassword/getSysPasswordConfig', payload: {} });
  }

  render() {
    const {form, loginStatus, loginImageLight, loading, theme, loginImageDark, errorMessage, showVerify = false} = this.props;
    const lightImages = {
      image: loginImageLight,
    };
    const darkImages = {
      image: loginImageDark,
    };
    const isDark = theme !== 'light';
    const images = !isDark ? lightImages : darkImages;
    const fillFixClass = isDark ? 'autofillLight' : 'autofillLight';
    const {getFieldDecorator} = form;
    const suffixHeight = 0.037 * window.innerHeight;
    const suffix =
      <div style={{height: suffixHeight}}>
        <canvas
          onClick={this.reloadPic}
          ref={this.canvas}
          width='100'
          height={suffixHeight}>
        </canvas>
      </div>;
    return (
      <div
        style={{
          background: `url(${wrapImage(`/static/images/login-pic-kyyzxjfcxxt.png`)}) top no-repeat`,
          backgroundSize: 'cover',
        }}
        className={`${styles.vadpLoginForHXYY_KYYZXJFCXXT} ${fillFixClass}`}>
        <div className={styles.container}>
          <img src={wrapImage(`/static/images/login-logo-hxyy-kyyzxjfcxxt.png`)} className={styles.logo}/>
          <span className={styles.title}>登录</span>
          {!loginStatus && this.renderErrorMessage(errorMessage)}
          <Form onSubmit={this.submit} className={styles.form}>
            <FormItem>
              {getFieldDecorator('username', {
                rules: [{
                  required: true, message: '请输入职工号',
                }],
              })(
                <Input
                  maxLength={32}
                  autocomplete="off"
                  placeholder="职工号"
                  onChange={this.onChange}
                  prefix={<Icon type="-user1" style={{color: '#FFFFFF'}}/>}
                />
              )}
            </FormItem>
            <FormItem>
              {getFieldDecorator('password', {
                rules: [{
                  required: true, message: '请输入密码',
                }],
              })(
                <Input
                  maxLength={32}
                  type="password"
                  placeholder="密码"
                  autocomplete="off"
                  onChange={this.onChange}
                  prefix={<Icon type="-password1" style={{color: '#FFFFFF'}}/>}
                />
              )}
            </FormItem>
            {showVerify && <FormItem>
              {getFieldDecorator('code', {
                rules: [{
                  required: true, message: '请输入校验码！',
                }],
              })(
                <Input
                  maxLength={4}
                  suffix={suffix}
                  onChange={this.changeCode}
                  placeholder="请输入校验码"
                />
              )}
            </FormItem>}
            <FormItem>
              <Button size="large" className="login-submit-btn" htmlType="submit" loading={loading}>
                登录
              </Button>
              {/*<div><a onClick={this.frogetPassword} style={{float: 'right', color: '#fff'}}>忘记密码?</a></div>*/}
            </FormItem>
          </Form>
          {/*<span style={{whiteSpace: 'pre-line', fontSize: 12, color: '#ffffff', position: 'absolute', bottom: '7.3%'}}>*/}
          {/*  温馨提示：<br/>*/}
          {/*  1、系统账号为职工号，初始密码请通过忘记密码找回<br/>*/}
          {/*  2、如遇登录问题，请联系科技部028-85422068</span>*/}
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    loginBackgroundImageLight: state.vadpLogin.loginBackgroundImageLight,
    loginLogoLight: state.vadpLogin.loginLogoLight,
    loginImageLight: state.vadpLogin.loginImageLight,
    loginLogo: state.vadpLogin.loginLogo,
    testLight: state.vadpLogin.testLight,
    theme: state.vadpLogin.theme,
    errorMessage: state.vadpLogin.errorMessage,
    loginImageDark: state.vadpLogin.loginImageDark,
    showVerify: state.vadpLogin.showVerify,
  };
}

export default connect(mapStateToProps)(Form.create()(LoginForHXYY_KYYZXJFCXXT));



// WEBPACK FOOTER //
// ./src/components/LoginForHXYY_KYYZXJFCXXT/index.js